<template>
  <div class="main-container">
    <tl-header type="h1">
        <div class="main-header">Compensation</div>
    </tl-header>
      <!-- <div class="compensationHeader">
        <p>Current/Previous</p>
        <tl-select class="searchDiv" :options="salaryOptions" placeholder="Current" v-model="salary" @change="(val)=> getData(val) "/>
      </div> -->
      <!-- <div class="twoColumnGridDashboard marginbottom-5p">
        <div class="salaryContent">
          <p>Earnings</p>
          <table class="reportTable">
            <tbody>
            <tr v-for="(item, index) in earningsData" :key="index">
              <td>{{item.name}}</td>
              <td>
                {{ item.monthly }}
              </td>
            </tr>
          </tbody>
          </table>
        </div>
        <div class="salaryContent">
          <p>Deductions</p>
          <table class="reportTable">
            <tbody>
            <tr v-for="(item, index) in deductionData" :key="index">
              <td>{{item}}</td>
              <td>
                {{ item }}
              </td>
            </tr>
          </tbody>
          </table>
        </div>
      </div> -->
      <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />    
      <btn-grp>
        <btn text="Download Compensation Report" type="primary" @click="downloadCtcReport()"/>
      </btn-grp>
      <div v-html="htmlContent" style="width: 65%;"></div>
    </div>
</template>

<script>

import { mapActions } from 'vuex';
export default {
  data() {
    return {
      salaryOptions: ["Current"],
      salary: "Current",
      currentsalaryData : [],
      prevSalaryData: [],
      salaryData: [],
      earningsData: [],
      deductionData: [],
      htmlContent: "",
      empCode: null, 
      errmsg: "",
      toast: false,
    };
  },

mounted() {
  //this.downloadCtcReport();
  //this.getEmployeeCompensation();
},

activated() {
  //this.getEmployeeCompensation();
},

computed: {
  le_id(){
    return localStorage.getItem("le_id")
  },

  empId(){
    return localStorage.getItem("empId")
  },
},

methods: {
  ...mapActions({
    act_getCompensation: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchEmployeeCompensation',
    act_getCtcReport: "dashboard/organisation/utilities/itsheetandpayslip/downloadCtcReport",
    act_getProfileData: 'dashboard/payroll/monthlypayroll/employeeProfile/fetchAll',
  }),

  getData(val){
    this.earningsData = [];
    this.deductionData = [];
    if(val == "Current"){
      this.salaryData = this.currentsalaryData;
      this.salaryData.length && this.salaryData.map(item => {
        if(item.transaction_type == "DEDUCTION" && item.monthly != "Not Available"){
          this.deductionData.push(item);
      } if(item.transaction_type == "EARNING" && item.monthly != "Not Available"){
          this.earningsData.push(item);
        }
      })
    } else {
      this.salaryData = this.prevSalaryData;
      this.salaryData.length && this.salaryData.map(item => {
        if(item.transaction_type == "DEDUCTION" && item.monthly != "Not Available"){
          this.deductionData.push(item);
      } if(item.transaction_type == "EARNING" && item.monthly != "Not Available"){
          this.earningsData.push(item);
        }
      })
    }
  },

  async getEmployeeCompensation() {
    try {
      let obj ={
        emp_id : this.empId,
        le_id: this.le_id
      }
      let currentSalary = [];
      let prevSalary = [];
      this.earningsData = [];
      this.deductionData = [];
      let res = await this.act_getCompensation(obj);
      if(res.data && res.data.payload){
        currentSalary = res.data.payload[0].masterSalaryDetails;
        prevSalary = res.data.payload[0].historySalaryDetails
      }
      let prevSalaryLength = prevSalary.length;
      if(prevSalaryLength > 1){
        this.salaryOptions.push("Previous");
        this.currentsalaryData = prevSalary[prevSalaryLength - 1];
        this.prevSalaryData = prevSalary[prevSalaryLength -2];
      } else if(prevSalaryLength == 1){
        this.salaryOptions.push("Previous");
        this.currentsalaryData = prevSalary[prevSalaryLength - 1];
        this.prevSalaryData = currentSalary;
      } else{
        this.currentsalaryData = currentSalary;
        this.prevSalaryData = [];
      }

      this.salaryData = this.currentsalaryData;
      this.salaryData.length && this.salaryData.map(item => {
        if(item.transaction_type == "DEDUCTION" && item.monthly != "Not Available"){
          this.deductionData.push(item);
      } if(item.transaction_type == "EARNING" && item.monthly != "Not Available"){
          this.earningsData.push(item);
        }
      })
    } catch (error) {
      this.toast = true;
      this.errmsg = error.message;
    }
  },

  async downloadCtcReport() {
      try {
        this.htmlContent = "";
        let obj = {
          'employee_id': this.empId
        };
        let response = await this.act_getProfileData(obj);
        this.employeeData = response.data.payload[0];
        this.empCode = this.employeeData.code
        let res = await this.act_getCtcReport({
          empCode: this.empCode, // PL_3042
        });
        // Define the string
        this.toast = false;
        const url = res.data.data.pdfPreSignedUrl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Payslip.pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.toast = true;
        this.errmsg = "Details not Fetched";
      }
    },
}
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins

/* .mainHeading {
  font-weight:550;
  color:rgba(18, 18, 20,0.690);
  font-style:inherit
} */

.main-header{
  font-size: 1.2rem;
  font-weight: bold;
  color: #777777;
}

.compensationHeader{
  padding: 0;
  margin-bottom: 20px;
}

.compensationHeader > p{
  color: #444444;
  font-size: 1rem;
  font-weight: 500;
  margin: 10px 0 10px;
}

.compensationHeader > * {
  margin-right: 20px;
}

.searchDiv{
  width: 200px;
}

.salaryContent{
    width: 100%;
    padding: 10px 15px 10px 15px;
    border-radius: 8px;
    border: solid 1px #F0F0F0;
    background-color: #f5f5f5;
    cursor: pointer;
}

.salaryContent > p{
  font-size: 1.2rem;
  font-weight: 500;
  padding: 10px 0;
  margin: 0;
  border-bottom: 2px solid #34C0BD;
}

.reportTable th,
    .reportTable td {
        padding: 0 10px 10px;
    }

    .reportTable tbody tr {
      display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.5px solid #dddddd;
    }

    .reportTable tbody tr .yearSelect{
        width: 170px;
    }
</style>
